import { useState } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import { ArraySectionsType, FormEventType } from '@pages/WindowsCreateOrEdit/types'

type TProps = {
  sectionIndex: number
  tabIndex: number
  actionIndex: number
}

export const useEvents = ({ sectionIndex, tabIndex, actionIndex }: TProps) => {
  const [isCreateEvent, setIsCreateEvent] = useState(false)

  const { control } = useFormContext<ArraySectionsType>()

  const {
    fields: events,
    append,
    remove,
  } = useFieldArray({
    control,
    name: `sections.${sectionIndex}.tabs.${tabIndex}.actions.${actionIndex}.events` as const,
  })

  const handleAddEvent = () => {
    if (isCreateEvent) {
      return
    }

    setIsCreateEvent(true)
  }

  const handleSaveNewEvent = (values: FormEventType) => {
    append(values)
    setIsCreateEvent(false)
  }

  const handleCancelCreate = () => {
    setIsCreateEvent(false)
  }

  const removeEvent = (index: number) => {
    remove(index)
  }

  return {
    events,
    isCreateEvent,
    handleAddEvent,
    handleSaveNewEvent,
    handleCancelCreate,
    removeEvent,
  }
}
